import React, { useContext, useState, useEffect } from 'react'
import { AddorderImage, NewTabOrderMenuWrapper, OrderstatusContainernew } from './Theme62ExtStyleComponent'
import { environmentVariables } from "../../../../config/env.config";
import { userContext } from "../../../../context/userContext";
import { useTranslation } from "react-i18next";
import axios from 'axios';  
import deleteVector from "../../../../Images/Restaurant/deleteVector.svg";
import prevVector from "../../../../Images/Restaurant/prevVector.svg";
import './tabOrder.css';

const TabOrder = ({ orderItems, removeItem, updatePrevTotal, updateTotalAmount, rs, colordata, setActiveTab, itemQuantities, setItemQuantities, setOrderItems }) => {
  const { userData } = useContext(userContext);
  const { t } = useTranslation();
  const [currencySymbol, setCurrencySymbol] = useState('₹');
  let customer_data = localStorage.getItem("Customer");
  let cusData = !!customer_data ? JSON.parse(customer_data) : "";

  useEffect(() => {
    const initialQuantities = {};
    orderItems.forEach((item, index) => {
      initialQuantities[index] = item.quantity || 1;
    });
    setItemQuantities(initialQuantities);
  }, [orderItems]);

  useEffect(() => {
    if (rs?.contactInfo?.content) {
      const contactInfo = JSON.parse(rs.contactInfo.content);
      const phoneNumber = contactInfo.contactInfoPhone;
      if (!!phoneNumber) {
        const countryCode = phoneNumber.match(/^\+(\d+)/)[1]; // Extract the country code

        switch (countryCode) {
          case '91':
            setCurrencySymbol('₹');
            break;
          case '1':
            setCurrencySymbol('$');
            break;
          case '971':
            setCurrencySymbol('AED');
            break;
          // Add other country codes and their currency symbols as needed
          default:
            setCurrencySymbol('₹'); // Default to INR
            break;
        }
      }
    }
  }, [rs?.contactInfo]);

  const increaseQuantity = (index, data) => {
    if (itemQuantities[index] >= 50) return;
    setItemQuantities((prevQuantities) => ({
      ...prevQuantities,
      [index]: (prevQuantities[index] || 1) + 1,
    }));
    const cartItems = JSON.parse(localStorage.getItem("addedItems")) || [];

    const updatedCart = cartItems.map((item) => {
      if (item.id === data.id) {
        return {
          ...item,
          quantity: (item.quantity || 1) + 1,
        };
      }
      return item;
    });

    localStorage.setItem("addedItems", JSON.stringify(updatedCart));
     if(cusData?.id){
          try {
            const response =  axios.put(
              `${environmentVariables?.apiUrl}api/v1/cart/updateCartById?product_id=${data?.id}&user_id=${cusData?.id}&quantity=${itemQuantities[index] + 1}`,
            );
          } catch (error) {
            console.log(error, "error")
            return;
          }
          }
  };

  const decreaseQuantity = (index, data) => {
    if (itemQuantities[index] > 1) {
      setItemQuantities((prevQuantities) => ({
        ...prevQuantities,
        [index]: prevQuantities[index] - 1,
      }));
      const cartItems = JSON.parse(localStorage.getItem("addedItems")) || [];

      const updatedCart = cartItems.map((item) => {
        if (item.id === data.id) {
          return {
            ...item,
            quantity: item.quantity - 1,
          };
        }
        return item;
      });

      localStorage.setItem("addedItems", JSON.stringify(updatedCart));

      if(cusData?.id){
        try {
          const response =  axios.put(
            `${environmentVariables?.apiUrl}api/v1/cart/updateCartById?product_id=${data?.id}&user_id=${cusData?.id}&quantity=${itemQuantities[index] - 1}`,
          );
        } catch (error) {
          console.log(error, "error")
          return;
        }
      }
    }
  };

  useEffect(() => {
    for (let el in itemQuantities) {
      let get = orderItems.map((elem, index) => {
        if (index == el) {
          elem.quantity = itemQuantities[el]
        } return el
      })
    }
  }, [itemQuantities])

  const handleRemoveItem = (index,id) => {
    removeItem(index);

    const updatedItems = [...orderItems];
    updatedItems.splice(index, 1);
    setOrderItems(updatedItems);
    localStorage.setItem("addedItems", JSON.stringify(updatedItems));
    setItemQuantities((prevQuantities) => {
      const updatedQuantities = { ...prevQuantities };
      delete updatedQuantities[index];
      return updatedQuantities;
    });
    if(cusData?.id){
      try {
        const response =  axios.delete(
          `${environmentVariables?.apiUrl}api/v1/cart/removeFromCart?product_id=${id}&user_id=${cusData?.id}`,
        );
        
      } catch (error) {
        console.log(error, "error")
        return;
      }
    }
  };

  const calculateTotalPrice = (price, quantity) => {
    const total = price * quantity;
    return parseFloat(total.toFixed(2));
  };

  const calculateCartTotal = () => {
    let total = 0;
    orderItems.forEach((item, index) => {
      total += calculateTotalPrice((item?.price), itemQuantities[index] || 1);
    });
    total = parseFloat(total.toFixed(2));
    updatePrevTotal(total);
    return total;
  };

  const calculateOtherCharges = () => {
    return 0;
  };

  const calculateTotalWithCharges = () => {
    const subtotal = calculateCartTotal();
    const otherCharges = calculateOtherCharges();
    return subtotal + otherCharges;
  };

  const handlePreviousClick = () => {
    setActiveTab("menu");
  }

  const HandleMenu = ()=>{
    setActiveTab("menu");
  }

  useEffect(() => {
    updateTotalAmount(calculateTotalWithCharges());
  }, [orderItems, itemQuantities]);

  //colordata helper functions
  const dynamic = (originalColor, dynamicName, whichColor, opacity = 1) => {
    const style = {};

    if (dynamicName === 'mainBg') {
      style[whichColor] = colordata?.dynamicMainBackgroundColor || originalColor;
    } else if (dynamicName === 'bg') {
      style[whichColor] = colordata?.dynamicBackgroundColor || originalColor;
    } else if (dynamicName === 'heading') {
      style[whichColor] = colordata?.dynamicTextHeadingColor || originalColor;
    } else if (dynamicName === 'desc') {
      style[whichColor] = colordata?.dynamicTextDescriptionColor || originalColor;
    } else if (dynamicName === 'cta') {
      style[whichColor] = colordata?.dynamicCtaColor || originalColor;
    } else if (dynamicName === 'ctaText') {
      style[whichColor] = colordata?.dynamicCtaTextColor || originalColor;
    }

    style.opacity = colordata.dynamicTextHeadingColor ? opacity : 1;
    return style;
  }

  return (
    <div className='tabOrderPage' style={dynamic('#121212', 'mainBg', 'backgroundColor')}>
      <div className="order-header" style={{borderBottom: colordata.dynamicBackgroundColor ? `1px solid ${colordata.dynamicBackgroundColor}` : '1px solid #1E1E1E'}}>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 16 14" fill="none" className="prev-vector" onClick={() => handlePreviousClick()}>
          <path style={dynamic('#FFF', 'heading', 'fill')} d="M13.7731 5.12506H4.82673L7.30827 2.64352C7.59457 2.35735 7.75547 1.96917 7.75556 1.56437C7.75566 1.15957 7.59494 0.771317 7.30877 0.485014C7.02261 0.198712 6.63443 0.0378152 6.22963 0.0377198C5.82483 0.0376244 5.43657 0.198338 5.15027 0.484506L1.50173 4.13305C0.835065 4.80155 0.460693 5.70712 0.460693 6.65122C0.460693 7.59532 0.835065 8.50089 1.50173 9.16939L5.15027 12.8179C5.43657 13.1041 5.82483 13.2648 6.22963 13.2647C6.63443 13.2646 7.02261 13.1037 7.30877 12.8174C7.59494 12.5311 7.75566 12.1429 7.75556 11.7381C7.75547 11.3333 7.59457 10.9451 7.30827 10.6589L4.82673 8.17738H13.7731C14.1779 8.17738 14.566 8.01659 14.8523 7.73038C15.1385 7.44417 15.2993 7.05598 15.2993 6.65122C15.2993 6.24646 15.1385 5.85827 14.8523 5.57206C14.566 5.28585 14.1779 5.12506 13.7731 5.12506Z" fill="none" />
        </svg>
        <div className="order-title" style={dynamic('#FFF', 'heading', 'color')}>{t("Confirm_order")}</div>
      </div>
      <NewTabOrderMenuWrapper className="tab-order-wrapper">
        <OrderstatusContainernew>
          <div>
            <div>
              {orderItems.length === 0 ? (
               <div className='empty-card-container'>
               <div className="empty-cart" style={dynamic('#FFF', 'heading', 'color')}>
                  {t("Card_empty")} <br /> 
                </div>
                  <button className='empty-cart-btn' onClick={HandleMenu}>Continue browsing</button>
               
               </div>
              ) : (
                <div className="order-items-container">
                  <div className="order-items-header">
                    <p className="items-text" style={dynamic('#FFF', 'heading', 'color')}>{t("Items")}</p>
                    <div>
                      <p className="total-items-text" style={dynamic('#FFF', 'heading', 'color', '0.7')}>{t("Total_items")} :&nbsp;<span>{orderItems.length}</span></p>
                    </div>
                  </div>
                  <div className="order-items-list">
                    {orderItems.map((item, index) => (
                      <div key={index} className="order-item" style={{borderBottom: colordata.dynamicBackgroundColor ? `1px solid ${colordata.dynamicBackgroundColor}` : '1px solid #1E1E1E'}}>
                        <div className="order-item-image" style={dynamic('#1B1B1B', 'bg', 'backgroundColor')}>
                          <AddorderImage src={
                            item?.image === "No image available"
                              ? `${environmentVariables.apiUrl}uploads/No image available.png`
                              : item?.image.includes('/')
                                ? `https://businessbay.b-cdn.net${item?.image}`
                                : `${environmentVariables.s3UrlBackendUrl}${item?.image}`
                          } alt='image' />
                        </div>
                        <div className="order-item-details">
                          <div className='order-item-top'>
                            <div className="order-item-name" style={dynamic('#FFF', 'heading', 'color')}>{item?.name}</div>
                            <div className="order-item-delete">
                              <img
                                src={deleteVector}
                                alt="delete"
                                onClick={() => handleRemoveItem(index,item.id)}
                              />
                            </div>
                          </div>
                          <div className="order-item-quantity">
                            {rs?.currency_symbol == "AED" ? (
                              <>
                            <span className="quantity" style={dynamic('#505050', 'heading', 'color', '0.7')}>{itemQuantities[index] || 1} x {parseFloat(item?.price).toFixed(2)} {rs?.currency_symbol}</span>
                              </>
                            ):(
                              <>
                            <span className="quantity" style={dynamic('#505050', 'heading', 'color', '0.7')}>{itemQuantities[index] || 1} x {rs?.currency_symbol}{parseFloat(item?.price).toFixed(2)}</span>
                              </>
                            )}
                          </div>
                          <div className='order-item-bottom'>
                            <div className="order-item-price" style={dynamic('#FF7622', 'heading', 'color')}>
                              {rs?.currency_symbol == "AED" ? (
                                <>
                              {calculateTotalPrice(item.price, itemQuantities[index] || 1).toFixed(2)} <span>{rs?.currency_symbol}</span>
                              </>
                              ):(
                                <>
                              <span>{rs?.currency_symbol}</span>{calculateTotalPrice(item.price, itemQuantities[index] || 1).toFixed(2)}
                              </>
                              )}
                            </div>
                            <div className="quantity-container">
                              <button
                                className="quantity-btn"
                                style={dynamic('#505050', 'heading', 'color', '0.7')}
                                onClick={() => decreaseQuantity(index, item)}
                              >
                                -
                              </button>
                              <span className="quantity-value" style={dynamic('#505050', 'heading', 'color', '0.7')}>{itemQuantities[index] || 1}</span>
                              <button
                                className="quantity-btn"
                                style={dynamic('#505050', 'heading', 'color', '0.7')}
                                onClick={() => increaseQuantity(index, item)}
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </OrderstatusContainernew>
      </NewTabOrderMenuWrapper>
    </div>
  )
}

export default TabOrder